import React from 'react';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { Services } from '../components/Services';
export function ServicesPage() {
  return <div className="min-h-screen bg-white selection:bg-teal-100 selection:text-teal-900" data-id="element-783">
      <Header data-id="element-784" />
      <main className="pt-32" data-id="element-785">
        <Services data-id="element-786" />
      </main>
      <Footer data-id="element-787" />
    </div>;
}